import { Box, Button, Container, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import FORBIDDEN from "../assets/images/common/triangle_warning.svg";
import ERROR from "../assets/images/common/clien_err.jpg";
import { ImageCustom } from "../components";

type Props = {};

const NotFound = (props: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",

        width: "100%",
        height: "100vh"
      }}
      title="403 Page No Access | Miko Admin"
    >
      <Box
        sx={{
          display: "flex",
          flex: "1 1 auto",
          // justifyContent: "center",
          alignItems: "center",
          // backgroundColor: "cyan"
          justifyContent: "space-evenly",
          margin: "0 200px"
        }}
      >
        <Box sx={{}}>
          <Typography
            style={{
              fontFamily: "IstokWeb",
              fontWeight: 700,
              fontSize: "170px",
              backgroundImage:
                "-webkit-linear-gradient(-45deg, #29435D 30%, #3091F3 90%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            404
          </Typography>
          <Box>
            <Typography
              style={{
                fontFamily: "IstokWeb",
                fontWeight: 700,
                fontSize: "34px"
              }}
            >
              Not found!
            </Typography>
            <Typography
              style={{
                fontFamily: "IstokWeb",
                fontWeight: 400,
                fontSize: "20px"
              }}
            >
              Không tìm thấy trang
            </Typography>
            <Button
              to="/"
              size="small"
              variant="contained"
              component={RouterLink}
              sx={{
                borderRadius: "8px",
                marginTop: "40px",
                backgroundColor: "#3091F3",
                width: "150px",
                height: "48px"
              }}
            >
              Trở về trang chủ
            </Button>
          </Box>
        </Box>
        <ImageCustom src={ERROR} width={"70vh"} height="70vh" />
      </Box>

      <Box
        sx={{
          flex: "0 1 auto",
          backgroundColor: "#22272D",
          display: "flex",
          justifyContent: "space-between",
          paddingRight: "100px",
          textAlign: "end",
          alignItems: "center"
        }}
      >
        <Box sx={{ opacity: "40%" }}>
          <ImageCustom src={FORBIDDEN} width={180} height={180} />
        </Box>
        <Box>
          <Typography
            sx={{
              color: "white",
              fontSize: "20px",
              lineHeight: 1.8
            }}
          >
            Không tìm thấy trang yêu cầu, trang không tồn tại hoặc đã bị xóa
          </Typography>
          <Typography
            sx={{
              color: "white",
              lineHeight: 1.8,
              fontSize: "20px"
            }}
          >
            Vui lòng kiểm tra lại đường dẫn
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NotFound;
